var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85512 0.146894C7.90168 0.193339 7.93863 0.248515 7.96383 0.30926C7.98904 0.370005 8.00201 0.435126 8.00201 0.500894C8.00201 0.566661 7.98904 0.631782 7.96383 0.692527C7.93863 0.753272 7.90168 0.808448 7.85512 0.854894L0.85512 7.85489C0.761233 7.94878 0.633896 8.00152 0.50112 8.00152C0.368344 8.00152 0.241006 7.94878 0.14712 7.85489C0.0532331 7.76101 0.000488282 7.63367 0.000488281 7.50089C0.00048828 7.36812 0.0532331 7.24078 0.14712 7.14689L7.14712 0.146894C7.19357 0.10033 7.24874 0.0633875 7.30949 0.0381811C7.37023 0.0129746 7.43535 0 7.50112 0C7.56689 0 7.63201 0.0129746 7.69275 0.0381811C7.7535 0.0633875 7.80867 0.10033 7.85512 0.146894Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146894 0.146894C0.100331 0.193339 0.0633875 0.248515 0.0381811 0.30926C0.0129746 0.370005 0 0.435126 0 0.500894C0 0.566661 0.0129746 0.631782 0.0381811 0.692527C0.0633875 0.753272 0.100331 0.808448 0.146894 0.854894L7.14689 7.85489C7.24078 7.94878 7.36812 8.00152 7.50089 8.00152C7.63367 8.00152 7.76101 7.94878 7.85489 7.85489C7.94878 7.76101 8.00152 7.63367 8.00152 7.50089C8.00152 7.36812 7.94878 7.24078 7.85489 7.14689L0.854894 0.146894C0.808448 0.10033 0.753273 0.0633875 0.692528 0.0381811C0.631782 0.0129746 0.566661 0 0.500894 0C0.435127 0 0.370005 0.0129746 0.30926 0.0381811C0.248515 0.0633875 0.193339 0.10033 0.146894 0.146894Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveInput);
export default __webpack_public_path__ + "static/media/remove-input.d8aad71c4c4a9401f09107a393d0704f.svg";
export { ForwardRef as ReactComponent };